function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


/* Animated top-level menu underline */

// Calculate and set the underline to new position
const moveUnderline = ( openDetails = null, mainMenu = null, paddingLeft = 0, paddingRight = 0 ) => {
  const elements = getMenuElements();
  const menuDetailsElement = openDetails === null ? elements.menuDetailsElement : openDetails;
  const menuElement = mainMenu === null ? elements.menuElement : mainMenu;
  const rect = menuDetailsElement.getBoundingClientRect();
  const rectX = rect.x === 0 ? 12 : rect.x;

  const mobileVisible = getComputedStyle(document.querySelector('header-drawer')).display;
  if (mobileVisible === 'block') {
    const styles = getComputedStyle(menuDetailsElement.querySelector('summary'));
    paddingLeft = styles.paddingLeft === 0 ? 16 : parseFloat(styles.paddingLeft);
    paddingRight = styles.paddingRight === 0 ? 10 : parseFloat(styles.paddingRight);
  }

  const width = menuDetailsElement.offsetWidth === 0 ? 71 : menuDetailsElement.offsetWidth
  const underlineWidth = (width - paddingLeft - paddingRight) / window.innerWidth;

  menuElement.style.setProperty('--underline-scale-x', underlineWidth );
  menuElement.style.setProperty('--underline-position-x', `${rectX + paddingLeft}px` );
}

// Return mobile menu if in mobile view, otherwise return desktop menu
function getMenuElements() {
  const mobileVisible = getComputedStyle(document.querySelector('header-drawer')).display;
  const menuElement = mobileVisible === 'none'
    ? document.querySelector('#MainMenu')
    : document.querySelector('#MobileMainMenu');
  const menuDetailsElement = menuElement.querySelector('details[open]');

  return { menuElement, menuDetailsElement };
}

// Run on initial page load to get initial position, add listener for window resize
moveUnderline();

window.addEventListener("resize", (event) => {
  moveUnderline();
});

// Open first top-level menu item on mouseleave
const headerHoverNavs = document.querySelectorAll('nav.hover-nav');
headerHoverNavs.forEach((headerHover) => {
  headerHover.addEventListener('mouseleave', (event) => {

    const detailsElements = event.currentTarget.querySelectorAll('ul details.menu-level-1');

    detailsElements.forEach((detailsElement, index) => {
      if (index != 0) {
        const summaryElement = detailsElement.querySelector('summary');
        detailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', 'false');
      }
    });

    const firstElement = detailsElements[0];
    const isOpen = firstElement.hasAttribute('open');
    if (!isOpen) {
      firstElement.setAttribute('open', '');
      firstElement.querySelector('summary').setAttribute('aria-expanded', 'true');
    }

    moveUnderline(firstElement);

  })
});

// Open the correct menu item on mouse hover, close other menus and move underline to new position
document.querySelectorAll('details.hover-open').forEach((detailsElement) => {
  detailsElement.addEventListener('mouseenter', (event) => {

    const openDetailsElements = event.currentTarget.closest('ul').querySelectorAll('details[open]');

    openDetailsElements.forEach((openDetailsElement) => {
      if (openDetailsElement !== event.target.closest('details')) {
        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', 'false');
      }
    });

    const isOpen = detailsElement.hasAttribute('open');
    if (!isOpen) {
      detailsElement.setAttribute('open', '');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
    moveUnderline(detailsElement);
  });

  detailsElement.addEventListener('mouseleave', (event) => {

    const openDetailsElements = event.currentTarget.closest('ul').querySelectorAll('details[open]');
      openDetailsElements.forEach((openDetailsElement) => {
        if (openDetailsElement !== event.currentTarget) {
          const summaryElement = openDetailsElement.querySelector('summary');
          openDetailsElement.removeAttribute('open');
          summaryElement.setAttribute('aria-expanded', 'false');
        }
      });
  });
})

document.querySelectorAll('details.hover-open-submenu').forEach((detailsElement) => {
  let showDelay = 300;
  let hideDelay = 400;
  let menuEnterTimer;
  let menuLeaveTimer;

  detailsElement.addEventListener('mouseenter', (event) => {

    const openDetailsElements = event.currentTarget.closest('ul').querySelectorAll('details[open]');

    clearTimeout(menuLeaveTimer);

    openDetailsElements.forEach((openDetailsElement) => {
      if (openDetailsElement !== event.target.closest('details')) {
        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', 'false');
      }
    });

    const isOpen = detailsElement.hasAttribute('open');
    if (!isOpen) {
      menuEnterTimer = setTimeout(function() {
        detailsElement.setAttribute('open', '');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', 'true');
      }, showDelay);
    }

  });

  detailsElement.addEventListener('mouseleave', (event) => {

    clearTimeout(menuEnterTimer);

    const openDetailsElements = event.currentTarget.closest('ul').querySelectorAll('details[open]');
    menuLeaveTimer = setTimeout(function() {
      openDetailsElements.forEach((openDetailsElement) => {
        if (openDetailsElement !== event.currentTarget) {
          const summaryElement = openDetailsElement.querySelector('summary');
          openDetailsElement.removeAttribute('open');
          summaryElement.setAttribute('aria-expanded', 'false');
        }
      });
    }, hideDelay);
  });

})

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');

  if(!summary.hasAttribute('aria-expanded')) {
    summary.setAttribute('aria-expanded', 'false');
  }


  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if (event.currentTarget.closest('ul')) {
      // Find all open menus on the same level and close them
      const openDetailsElements = event.currentTarget.closest('ul').querySelectorAll('details[open]');
      const detailsElement = event.currentTarget.closest('details');
      const isOpen = detailsElement.hasAttribute('open');

      openDetailsElements.forEach((openDetailsElement) => {
        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', 'false');
      });
    }

    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.querySelectorAll('[data-toggler]').forEach((toggler) => {
  toggler.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    /*
      Toggler:
      <button data-toggler aria-controls="element-id"></button>

      Toggler target:
      <div id="element-id"></div>

      When toggled, "is-expanded" class is added to target element and aria-expanded status is updated on toggler button.
    */

    const togglerTargetId = toggler.getAttribute('aria-controls');
    const togglerTarget = document.getElementById(togglerTargetId);
    if (!togglerTarget) {
      console.warn('Invalid or missing toggler target.');
      return;
    };

    const currentExpandedStatus = toggler.getAttribute('aria-expanded') || false;
    const currentExpandedStatusIsTrue = (currentExpandedStatus === 'true');

    // Loop through all togglers with same target to set same class.
    const similarTogglers = document.querySelectorAll(`[data-toggler][aria-controls="${togglerTargetId}"]`);
    similarTogglers.forEach((togglerSync) => {
      togglerSync.setAttribute('aria-expanded', !currentExpandedStatusIsTrue);
    });

    togglerTarget.classList.toggle('is-expanded');
    document.body.classList.toggle('drawer-open');

    togglerTarget.focus();
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  let elements = getFocusableElements(container);
  let first = elements[0];
  let last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    // Get all elements with the class "quantity-selector"
    const quantitySelectors = document.querySelectorAll('.quantity-selector');
    
    // Add an event listener to each quantity selector
    quantitySelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        // Get the changed value
        const changedValue = selector.value;
    
        // Update the value of all other quantity selectors
        quantitySelectors.forEach(otherSelector => {
          // Avoid updating the same input that triggered the change event
          if (otherSelector !== selector) {
            otherSelector.value = changedValue;
          }
        });
      });
    });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.input.addEventListener('change', this.updateDiscountTiers.bind(this))
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    //this.updateDiscountTiers();
  }

  updateDiscountTiers(event) {
    const discountTiers = document.querySelector('discount-tiers');
    if (!discountTiers) return;
    discountTiers.updateDiscounts();
  }
}

customElements.define('quantity-input', QuantityInput);

class DiscountTiers extends HTMLElement {
  constructor() {

    super();
    this.changeEvent = new Event('change', { bubbles: true })
    this.quantityInput = document.querySelector('.product-form__input quantity-input input');
    this.updateDiscounts();
    this.bindEventListeners();
  }

  bindEventListeners() {
    this.querySelectorAll('[data-product-discount-tier]').forEach(
      (input) => input.addEventListener('change', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {

    const previousValue = this.quantityInput.value;
    const newQty = event.target.dataset.quantity;
    if (previousValue !== newQty) {
      // update new qty
      this.quantityInput.value = newQty;
      this.quantityInput.dispatchEvent(this.changeEvent);
    }
  }

  updateDiscounts(discounted) {
    const quantity = parseInt(this.quantityInput.value);
    // check the correct discount tier box if it exists
    const discountTiersBlock = document.querySelector('.product-discount-tiers-block');
    if (!discountTiersBlock) return;

    const discountTiers = discountTiersBlock.querySelectorAll('input[data-quantity]');
    let discountTier;
    for (let i = discountTiers.length - 1; i >= 0; i--) {
      let tierQty =  parseInt(discountTiers[i].dataset.quantity);
      if (tierQty <= quantity) {
        discountTier = discountTiers[i];
        discountTier.checked = true;
        break;
      }
    }

    this.updatePrices(discounted, discountTier, quantity);
  }

  updatePrices(discounted, discountTier, quantity) {
    const vvProductInfo = document.querySelector('.current_variant-price');
    const priceContainers = document.querySelectorAll('.product__info-wrapper div.price');
    const regularPriceElems = vvProductInfo.querySelectorAll('div.price .price__regular .price-item--regular');
    const salePriceElems = vvProductInfo.querySelectorAll('div.price .price__sale .price-item--sale');
    const stickySalePriceElems = document.getElementById('sticky-price__sale');

    if (!discountTier) return;

    const discountedPrice = formatPrice(discountTier.value);
    regularPriceElems.forEach(elem => {
      elem.textContent = discountedPrice;
    });
    salePriceElems.forEach(elem => {
      elem.textContent = discountedPrice;
    });
    // Lifting Bakker 
    stickySalePriceElems.textContent = discountedPrice;
    
    if (discounted) this.discountedVariant = discounted;

    priceContainers.forEach(elem => {
      if (quantity > 1) {
        elem.classList.add('price--on-sale');
      } else if (!this.discountedVariant) {
        elem.classList.remove('price--on-sale');
      }
    });

  }
}
customElements.define('discount-tiers', DiscountTiers);


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.formatMoney = function(cents, format) {
  var default_money_format = "€{{amount}}";
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || default_money_format);

  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
  };

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.firstLevelMenus = this.querySelectorAll('details.menu-level-1 > summary');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
    this.mobileMainMenu = document.querySelector('#MobileMainMenu');
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.firstLevelMenus.forEach(summary => summary.addEventListener('mouseenter', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;

    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }

    if ( summaryElement.classList.contains("menu-drawer__menu-level-1") ){
      moveUnderline( detailsElement );
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      // Open first submenu by default
      // this.mainDetailsToggle.querySelector('.menu-drawer__menu > li > details > summary').click();
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        //details.removeAttribute('open');
        //details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('header');
    this.showDelay = 300;
    this.hideDelay = 400;
    this.menuEnterTimer;
    this.menuLeaveTimer;
    this.bindEvents();
  }
  bindEvents() {
    document.querySelectorAll('details.hover-open').forEach((detailsElement) => detailsElement.addEventListener('mouseenter', this.onMouseEnter.bind(this)));
    document.querySelectorAll('details.hover-open').forEach((detailsElement) => detailsElement.addEventListener('mouseleave', this.onMouseLeave.bind(this)));
  }
  onMouseEnter(event) {
    const detailsElement = event.target;
    const openDetailsElements = event.currentTarget.closest('ul').querySelectorAll('details[open]');

    openDetailsElements.forEach((openDetailsElement) => {
      if (openDetailsElement !== event.target.closest('details')) {
        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', 'false');
      }
    });

    const isOpen = detailsElement.hasAttribute('open');
    if (detailsElement.classList.contains('hover-open-submenu')) {
      clearTimeout(this.menuLeaveTimer);
      if (!isOpen) {
        this.menuEnterTimer = setTimeout(function() {
          detailsElement.setAttribute('open', '');
          detailsElement.querySelector('summary').setAttribute('aria-expanded', 'true');
        }, this.showDelay);
      }
    } else {
      if (!isOpen) {
        detailsElement.setAttribute('open', '');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', 'true');
      }
    }

  }
  onMouseLeave(event) {
    clearTimeout(this.menuEnterTimer);

    const openDetailsElements = event.currentTarget.closest('ul').querySelectorAll('details[open]');
    this.menuLeaveTimer = setTimeout(function() {
      openDetailsElements.forEach((openDetailsElement) => {
        if (openDetailsElement !== event.currentTarget) {
          const summaryElement = openDetailsElement.querySelector('summary');
          openDetailsElement.removeAttribute('open');
          summaryElement.setAttribute('aria-expanded', 'false');
        }
      });
    }, this.hideDelay);
  }
}

customElements.define('header-menu', HeaderMenu);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      }
    )
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    const container = this.querySelector('[role="document"]');
    container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

customElements.define('product-modal', ProductModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotElements = this.querySelectorAll('.slider-dot');
    this.verticalSlider = this.querySelector('.vertical-slider');
    this.verticalSliderUl = this.querySelector(`[id*="Slider-Thumbnails"]`);

    this.comparedImage = document.querySelector('.product__media-list');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if (this.verticalSliderUl && this.comparedImage) {
      this.resizeSlider();
      window.addEventListener('resize', this.resizeSlider.bind(this));
    }
  }


  resizeSlider() {
    const imageHeight = this.comparedImage.clientHeight;
    // Maj Image Bakker
    if (imageHeight != 0) {
      this.verticalSliderUl.style.height = `${imageHeight}px`;
    } else {
      console.warn('%cimageHeight at zero', 'color: black; background-color: yellow;');
    }
  }


  initPages() {
    if (this.verticalSlider) {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientHeight > 0);
    } else {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    }
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    if (this.verticalSlider) {
      this.slidesPerPage = Math.floor(this.slider.clientHeight / this.sliderItemsToShow[0].clientHeight);
    } else {
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    }
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {

    const previousPage = this.currentPage;

    if (this.verticalSlider) {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderLastItem.clientHeight) + 1;
    } else {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if (this.dotElements) {
      for (var dotElement of this.dotElements) {
        if (dotElement.dataset.pos == this.currentPage) {
          dotElement.classList.add("active");
        }
        else dotElement.classList.remove("active");
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    if(this.verticalSlider) {
      const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
      return (element.offsetTop + element.clientHeight) <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
    } else {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if (this.verticalSlider) {
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollTop + (step * this.sliderLastItem.clientHeight) : this.slider.scrollTop - (step * this.sliderLastItem.clientHeight);
      this.slider.scrollTo({
        top: this.slideScrollPosition
      });
    } else {
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');
    this.nextButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}


customElements.define('slideshow-component', SlideshowComponent);

function initPotScroller() {
    const prevButton = document.getElementById('vv-prev');
    const nextButton = document.getElementById('vv-next');
    const sliderContainer = document.getElementById('vv-slider-container');
    const productContainer = document.getElementById('vv-container-spc-product');

    if (!prevButton || !nextButton || !sliderContainer || !productContainer) {
        return; // rien à initialiser
    }

    let scrollAmount = 0;
    const step = sliderContainer.clientWidth / 1;

    updateButtons();

    prevButton.addEventListener('click', function () {
        scrollAmount = Math.max(scrollAmount - step, 0);
        productContainer.style.transform = `translateX(-${scrollAmount}px)`;
        updateButtons();
    });

    nextButton.addEventListener('click', function () {
        const maxScroll = productContainer.scrollWidth - sliderContainer.clientWidth;
        scrollAmount = Math.min(scrollAmount + step, maxScroll);
        productContainer.style.transform = `translateX(-${scrollAmount}px)`;
        updateButtons();
    });

    function updateButtons() {
        const maxScroll = productContainer.scrollWidth - sliderContainer.clientWidth;

        prevButton.style.display = scrollAmount === 0 ? 'none' : '';
        nextButton.style.display = scrollAmount >= maxScroll ? 'none' : '';
    }
}


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantLoad() {
    this.updateOptions();
    this.updateMasterId();
    this.updateTweakwiseId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // MAJ
      //this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateDiscountBadge();
    }
        const variant = this.currentVariant;
    if (!variant || !variant.id) return;

    const container = document.querySelector('#vv-pot-container');
    if (!container) return;

    const url = `${window.location.pathname}?variant=${variant.id}&section_id=${this.dataset.section}`;

    fetch(url)
        .then(res => res.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContainer = doc.querySelector('#vv-pot-container');

            if (newContainer) {
                container.innerHTML = newContainer.innerHTML;

                // IMPORTANT : réinitialise le slider ici
                initPotScroller();
            }
        })
        .catch(err => console.error("Erreur MAJ pots :", err));
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateTweakwiseId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateAvailability();
      // MAJ
      // this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateVariantIdOnButton();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateDiscountBadge();
      this.updateSku();
      // this.vvHideOtherVariantsMedia();
      // this.vvUpdateCurrrentProductMedia();
    }
        const variant = this.currentVariant;
    if (!variant || !variant.id) return;

    const container = document.querySelector('#vv-pot-container');
    if (!container) return;

    // pour info / debug
    container.setAttribute('data-variant-id', variant.id);

    const sectionId = this.dataset.section; // important : data-section="{{ section.id }}" dans la section
    const url = `${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`;

    fetch(url)
        .then(res => res.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContainer = doc.querySelector('#vv-pot-container');

            if (newContainer) {
                container.innerHTML = newContainer.innerHTML;
            }

            // Réinitialise le scroll/slider si nécessaire
            if (typeof initPotScroller === 'function') initPotScroller();
        })
        .catch(err => console.error("Erreur MAJ pots :", err));
  }

  
vvUpdateCurrrentProductMedia() {
  const vvVariantMediaListDesktop = document.querySelectorAll('.vv_variant_image');
  const vvVariantImageListMobile = document.querySelectorAll('.vv_variant_image_mobile');
  var vvVariantThumbnail = document.querySelector(`.vv-thumbnail-button[vv-variant-id="${this.currentVariant.id}"]`);
  if (vvVariantThumbnail) {
      vvVariantThumbnail.click();
  }
}
  
//Hide other Variant media after selecting a variant
  vvHideOtherVariantsMedia() {
  const vvVariantMediaListDesktop = document.querySelectorAll('.vv_variant_image');
  const vvVariantImageListMobile = document.querySelectorAll('.vv_variant_image_mobile');
  const vvCurrentVariantId = this.currentVariant.featured_media.id;

vvVariantMediaListDesktop.forEach(variantMediaDesktop => {
  const vvMediaId = variantMediaDesktop.getAttribute('vv-media-id');
  if (vvMediaId != vvCurrentVariantId) {
    variantMediaDesktop.style.display = 'none';
  } else {
    variantMediaDesktop.style.display = '';
  }
});

const hasActiveClass = Array.from(vvVariantImageListMobile).some(element => element.classList.contains('is-active'));

if (hasActiveClass) {
  vvVariantImageListMobile.forEach(variantMediaMobile => {
    const vvMediaListId = variantMediaMobile.getAttribute('vv-media-id');
    
    if (vvMediaListId != vvCurrentVariantId) {
      variantMediaMobile.style.display = 'none';
      variantMediaMobile.classList.remove('is-active');
    } else {
      document.querySelectorAll('.is-active').forEach(activeElement => {
        activeElement.classList.remove('is-active');
      });

      variantMediaMobile.style.display = '';
      variantMediaMobile.classList.add('is-active');
    }
  });
}
}

updateAvailability () {
      const variants = document.querySelectorAll('availability-date[current-variant]');
      variants.forEach( variant => variant.setAttribute('current-variant', this.currentVariant.id));
}

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateTweakwiseId() {
    // 06/07/2023 enleve tweakwise 
    // document.querySelectorAll('tweakwise-recommendations').forEach((elem) => {
    //   let options = JSON.parse(elem.dataset.tweakwise);
    //   options.recommendedProductId = this.currentVariant && this.currentVariant.id;
    //   elem.dataset.tweakwise = JSON.stringify(options);

    // });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);

    if (!modalContent) return;

    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

    var replaceUrl = `${this.dataset.url}?variant=${this.currentVariant.id}`;

    // preserve refererrer params in the url
    if (!document.referrer.includes(window.location.hostname)) {

      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);

      if (window.location.href.includes(replaceUrl)) {
        params = window.location.href.split(replaceUrl)[1].replace(/^./, '&');
      } else {
        params = `&${params.toString()}`;
      }
      if (!this.referrerParams) { this.referrerParams = params };
      if (this.referrerParams && this.referrerParams.length > 0) {
        replaceUrl = `${replaceUrl}${this.referrerParams}`;
      }

    }
    window.history.replaceState({ }, '', replaceUrl);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantIdOnButton() {
    const buttons = document.querySelectorAll('.vv-add-to-cart-main');

    buttons.forEach((button) => {
      if (this.currentVariant && this.currentVariant.id) {
        button.setAttribute('variantid', this.currentVariant.id);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateDiscountBadge() {
    const discountTiers = document.getElementById('discountTiers');
    const price = this.currentVariant.price;
    const compareAtPrice = this.currentVariant.compare_at_price;
    const badge = document.querySelector(".pdp-discount__badge");
    const mobileBadge = document.getElementById("mobile-pdp-discount__badge");

    if (price < compareAtPrice) {
      let salePercentage = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
      const newInnerHtml = badge.dataset.text.replace(/\{\{(.+?)\}\}/g, salePercentage);
      badge.innerHTML = newInnerHtml;
      let formattedPercentage = '-' + salePercentage.toString() + '%';
      mobileBadge.innerHTML = formattedPercentage;
      badge.classList.remove("hidden");
      mobileBadge.classList.remove("hidden");
    }
    else {
      badge.classList.add("hidden");
      mobileBadge.classList.add("hidden");
    }
  }

  updateSku() {
    let productSku =
      this.querySelector("[data-product-sku-container]") ||
      document.querySelector(".product [data-product-sku-container]");
    if (!productSku) {
      return;
    }
    let productSkuNumber = productSku.querySelector(
      "[data-product-sku-number]"
    );
    if (!this.currentVariant || !this.currentVariant.sku) {
      productSku.style.display = "none";
    } else {
      productSkuNumber.innerHTML = this.currentVariant.sku;
      productSku.style.display = "";
    }
    let productSkuMobile = document.getElementById('sku-number-mobile');
    if(productSkuMobile) {
      productSkuMobile.innerHTML = this.currentVariant.sku;
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const idMobile = `price-${this.dataset.section}-2`;
        const idStickyMobile = `price-${this.dataset.section}-mobile`;
        const idGraduatedDiscounts = `product-discounts-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const destinationMobile = document.getElementById(idMobile);
        const destinationStickyMobile = document.getElementById(idStickyMobile);
        const destinationGraduatedDiscounts = document.getElementById(idGraduatedDiscounts);
        const source = html.getElementById(id);
        const sourceMobile = html.getElementById(idMobile);
        const sourceStickyMobile = html.getElementById(idStickyMobile);
        const sourceGraduatedDiscounts = html.getElementById(idGraduatedDiscounts);

        if (source && destination) destination.innerHTML = source.innerHTML;

        if (sourceMobile && destinationMobile) destinationMobile.innerHTML = sourceMobile.innerHTML;

        if (sourceStickyMobile && destinationStickyMobile) destinationStickyMobile.innerHTML = sourceStickyMobile.innerHTML;

        if (sourceGraduatedDiscounts && destinationGraduatedDiscounts) {
          destinationGraduatedDiscounts.innerHTML = sourceGraduatedDiscounts.innerHTML;
          const discountTiers = destinationGraduatedDiscounts.closest('discount-tiers');
          const discounted = this.currentVariant.price < this.currentVariant.compare_at_price;
          discountTiers.updateDiscounts(discounted);
          discountTiers.bindEventListeners();
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceMobile = document.getElementById(`price-${this.dataset.section}-2`);
        const priceStickyMobile = document.getElementById(`price-${this.dataset.section}-mobile`);

   //     if (price) price.classList.remove('visibility-hidden');
  //      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        if (priceMobile) priceMobile.classList.remove('visibility-hidden');
        if (priceStickyMobile) priceStickyMobile.classList.remove('visibility-hidden');

        const destinationUsp = document.querySelector('.usp-text__container');
        const sourceUsp = html.querySelector('.usp-text__container');
        if (destinationUsp && sourceUsp) {
          destinationUsp.innerHTML = sourceUsp.innerHTML;
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productFormMobile = document.getElementById(`sticky-footer--form`);
    if (!productForm) return;
    if (!productFormMobile) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const addButtonIcon = productForm.querySelector('[name="add"] > svg')

    const addButtonMobile = productFormMobile.querySelector('[name="add"]');
    const addButtonTextMobile = productFormMobile.querySelector('[name="add"] > span');

    if (!addButton) return;
    if (!addButtonMobile) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonMobile.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (text) addButtonTextMobile.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;

      addButtonMobile.removeAttribute('disabled');

      if( addButtonIcon ) {
        addButtonIcon.classList.remove('hidden');
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const addButtonIcon = button.querySelector('[name="add"] > svg');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if(addButtonIcon) {
      addButtonIcon.classList.add('hidden');
    }
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    if (this.querySelector('fieldset').querySelector('input') && this.querySelector('fieldset').querySelectorAll('input:checked').length === 0) {
      this.querySelector('fieldset').querySelector('input').checked = true;
    }
    this.onVariantLoad();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const radios = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return radios && radios.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class CountrySelector extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') ===
      'false').toString());
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.hidePanel();
    })
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('country-selector', CountrySelector);

function formatPrice(price) {
  const priceDivided = price / 100; // use if cents are passed
  const shopifyPreferredLanguage = window.top?.Shopify?.locale || 'en-US';
  const shopifyPreferredCurrency = window.top?.Shopify?.currency?.active || 'EUR';

  const formattedPrice = new Intl.NumberFormat(shopifyPreferredLanguage, {
    style: 'currency',
    currency: shopifyPreferredCurrency,
    minimumFractionDigits: 2, // min decimals.
    maximumFractionDigits: 2 // max decimals.
  }).format(priceDivided);

  return formattedPrice;
}

/* Video controls for video banner block */
let bannerVideo = document.getElementById("bannerVideo");
let bannerBtn = document.getElementById("bannerBtn");

function bannerVideoPlay() {
  event.stopPropagation();
  if (bannerVideo.paused) {
    bannerVideo.play();
    bannerBtn.classList.add("hidden");
  }
}
function bannerVideoPause() {
  if (bannerVideo.play) {
    bannerVideo.pause();
    bannerBtn.classList.remove("hidden");
  }
}


/* Video controls for four steps block */
let stepsVideo = document.getElementById("stepsVideo");
let stepsBtn = document.getElementById("stepsVideoBtn");

function stepsVideoPlay() {
  if (stepsVideo.paused) {
    stepsVideo.play();
    stepsBtn.classList.add("hidden");
  }
}
function stepsVideoPause() {
  if (stepsVideo.play) {
    stepsVideo.pause();
    stepsBtn.classList.remove("hidden");
  }
}

class GrabElement extends HTMLElement {
  constructor() {
    super();

    // Si l'élement est directement appelé uniquement
    if (this.nodeName === "GRAB-ELEMENT") {
      this.cssSelector = this.getAttribute("target");

      // Permet de lancer le monitoring du viewport
      this.matchMedia = this.getAttribute("match-media");
    }
  }

  connectedCallback() {
    if (!this.cssSelector) return;

    if (this.matchMedia) {
      this.mql = window.matchMedia(this.matchMedia);

      this.bindedHandleMediaChange = this.handleMediaChange.bind(this);
      this.mql.addEventListener("change", this.bindedHandleMediaChange);
    }

    const result = this.monitorElem();
    if (!result) this.detectElem();
  }

  disconnectedCallback() {
    this.mql.removeEventListener("change", this.bindedHandleMediaChange);
  }

  moveElem() {
    // Si l'élemenbt visié n'y est pas on sort (on peut être directement appelé parla media query)
    if (!this.elementToMove) return;

    // Cas sans usage des media query
    if (!this.matchMedia) {
      if (this.firstChild) this.firstChild.replaceWith(this.elementToMove);
      else this.appendChild(this.elementToMove);
    }

    // Cas d'usages avec des media query
    else {
      // Si on matche
      if (this.mql.matches) {
        // on capture la position initiale pour le remettre
        this.sourceParentElement = document.createElement("div");
        this.elementToMove.parentNode.insertBefore(
          this.sourceParentElement,
          this.elementToMove
        );
        if (this.firstChild) this.firstChild.replaceWith(this.elementToMove);
        else this.appendChild(this.elementToMove);
      }
      // si ça ne matche pas ont le remet dans la position initiale
      else if (this.firstChild) {
        this.sourceParentElement.replaceWith(this.elementToMove);
      }
    }
  }

  checkElem() {
    // On vérifie que l'élément est toujours là
    if (!this.elementToMove) return;

    this.moveElem();
  }

  monitorElem() {
    const elems = document.querySelectorAll(this.cssSelector);

    // On vérifie que l'élément ne correspond pas à celui déjà déplacé
    const elem = [...elems].find((node) => !node.parentNode.isSameNode(this));
    if (!elem) return false;

    this.elementToMove = elem;

    this.checkElem();

    return true;
  }

  detectElem() {
    const config = {
      childList: true,
    };

    this.bindedCallback = this.mutationObserverCallback.bind(this);

    this.mutationObserver = new MutationObserver(this.bindedCallback);
    this.mutationObserver.observe(document.body, config);
  }

  mutationObserverCallback() {
    const result = this.monitorElem();
    if (result) this.mutationObserver.disconnect();
  }

  handleMediaChange() {
    this.moveElem();
  }
}

customElements.define("grab-element", GrabElement);

// Plier Details et Description sur mobile
const vvMobileSpecificatiesAccordion = document.getElementById('Details-specificaties');
const vvMobileDescriptionAccordion = document.getElementById('Details-description');

if (vvMobileSpecificatiesAccordion || vvMobileDescriptionAccordion) {
  function vvIsMobileView(vvWidth) {
    if (vvWidth.matches) { 
        vvMobileSpecificatiesAccordion.removeAttribute("open");
        vvMobileDescriptionAccordion.removeAttribute("open");
    }
  }
  
  var vvWidth = window.matchMedia("(max-width: 749px)");
  vvIsMobileView(vvWidth);
  
  vvWidth.addEventListener("change", function() {
    vvIsMobileView(vvWidth);
  });
}

// Change la quantité sur le selecteur au clique des blocs remises
window.onload = function() {
  setInterval(function () {
   syncDiscountQty();  
 }, 1000);
  
  function syncDiscountQty() {
    var discount_btn_tier = document.getElementsByName('product-discount-tier');
    var quantity_selector = document.getElementsByClassName('quantity-selector');
    if (discount_btn_tier) {
      for(var i = 0; i < discount_btn_tier.length; i++) {
          var  discount_btn = discount_btn_tier[i];
           discount_btn.onclick = function() {
              // Loop through each element with the class "quantity-selector"
              for (var j = 0; j < quantity_selector.length; j++) {
                  quantity_selector[j].value = this.getAttribute("data-quantity");
              }
          }
      }
    }
  }

  function updatePriceOnDiscountChange(discountedVariantPrice, quantity) {
    var singleProductPrice = document.getElementById('productPrice');
    if (singleProductPrice) {
      singleProductPrice.innerText = discountedVariantPrice;
    }
    
    var productPrice =document.getElementsByClassName('price-item price-item--sale price-item--last')[0];
    if (productPrice) {
      productPrice.innerText = discountedVariantPrice;
    }
  }

 // Get all elements with the class "quantity-selector"
 const quantitySelectors = document.querySelectorAll('.quantity-selector');
 
 // Add an event listener to each quantity selector
 quantitySelectors.forEach(selector => {
   selector.addEventListener('change', () => {
     // Get the changed value
     const changedValue = selector.value;
 
     // Update the value of all other quantity selectors
     quantitySelectors.forEach(otherSelector => {
       // Avoid updating the same input that triggered the change event
       if (otherSelector !== selector) {
         otherSelector.value = changedValue;
       }
     });
    });
 });


  var inputs = document.getElementsByClassName('quantity-selector');
  var discount_radio = document.getElementsByName('product-discount-tier');
  
  for (var i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('change', function() {
      var inputValue = parseInt(this.value);
  
      if (discount_radio){
        if (inputValue > parseInt(discount_radio[0].getAttribute("data-quantity")) && inputValue >= parseInt(discount_radio[1].getAttribute("data-quantity")) && inputValue < parseInt(discount_radio[2].getAttribute("data-quantity"))) {
          discount_radio[1].checked = 'true';
          var discountedVariantPrice = discount_radio[1].getAttribute('data-current-variant-price')
          updatePriceOnDiscountChange(discountedVariantPrice, inputValue);
        } else if (inputValue >= parseInt(discount_radio[2].getAttribute("data-quantity")) && inputValue < parseInt(discount_radio[3].getAttribute("data-quantity"))) {
          discount_radio[2].checked = 'true';
          var discountedVariantPrice = discount_radio[2].getAttribute('data-current-variant-price')
          updatePriceOnDiscountChange(discountedVariantPrice, inputValue);
        } else if (inputValue >= parseInt(discount_radio[3].getAttribute("data-quantity"))) {
          discount_radio[3].checked = 'true';
          var discountedVariantPrice = discount_radio[3].getAttribute('data-current-variant-price')
          updatePriceOnDiscountChange(discountedVariantPrice, inputValue);
        } else {
          discount_radio[0].checked = 'true';
          var discountedVariantPrice = discount_radio[0].getAttribute('data-current-variant-price')
          updatePriceOnDiscountChange(discountedVariantPrice, inputValue);
        }
      }
    });
  }
}


document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.querySelector(".vv-toggle-button-shipping");
  const content = document.getElementById("vv-more-info-sup");
  if (toggleBtn && content) {
    toggleBtn.addEventListener("click", () => {
      const expanded = toggleBtn.getAttribute("aria-expanded") === "true";
      toggleBtn.setAttribute("aria-expanded", !expanded);
      content.hidden = expanded;
    });
  }
});

(function(){
  function bindFAQ(root){
    if (!root || root.dataset.faqBound === 'true') return;
    root.dataset.faqBound = 'true';

    const items = root.querySelectorAll('.faq-accordion__item');
    items.forEach((item) => {
      const btn = item.querySelector('.faq-accordion__trigger');
      const panel = item.querySelector('.faq-accordion__panel');
      if (!btn || !panel) return;

      // S'assurer que le premier item démarre ouvert si aria-expanded=true
      const startOpen = btn.getAttribute('aria-expanded') === 'true';
      if (startOpen){
        item.classList.add('is-open');
        panel.hidden = false;
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.hidden = true;
        panel.style.maxHeight = 0;
      }

      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        // Fermer tous les autres
        items.forEach((other) => {
          if (other === item) return;
          const b = other.querySelector('.faq-accordion__trigger');
          const p = other.querySelector('.faq-accordion__panel');
          other.classList.remove('is-open');
          if (b) b.setAttribute('aria-expanded','false');
          if (p){
            p.hidden = true;
            p.style.maxHeight = 0;
          }
        });

        // Basculer l'item courant
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
        if (!isOpen){
          panel.hidden = false;
          // forcer reflow puis animer à la bonne hauteur
          requestAnimationFrame(() => {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          });
        } else {
          panel.style.maxHeight = 0;
          // cacher après l’animation pour l’accessibilité
          panel.addEventListener('transitionend', function onEnd(e){
            if (e.propertyName === 'max-height'){
              panel.hidden = true;
              panel.removeEventListener('transitionend', onEnd);
            }
          });
        }
      });
    });
  }

  function initAll(){
    document.querySelectorAll('.shopify-section--faq').forEach(bindFAQ);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Support éditeur Shopify
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.closest('.shopify-section--faq') || e.target;
    bindFAQ(section);
  });
})();